import React, { useEffect } from 'react';
import { Text, TextTypes } from '../../components/index';
import { Container, Row, Col } from 'react-bootstrap';
import './faq.scss';
import data from './faq.data';
import FaqBlock from '../../components/faq-block/faq-block';
import styleLoader from '../../components/style-loader/style-loader';
import storage from '../../services/localStorage.service';

interface FaqProps {
    history: any;
}

function Faq(props: FaqProps) {
    console.log('faq props', props);

    useEffect(() => {
        // DOM method is used because content div is somewhere else
        const content: HTMLDivElement | null = document.querySelector('.content');
        if (content) content.scrollTop = 0;
    }, []);

    return (
        <Container fluid className="faq">
            <Row>
                <Col className="d-none d-md-block faq-title">
                    <Text type={TextTypes.H2}>Frequently Asked Questions</Text>
                </Col>
                <Col className="d-md-none d-sm-block faq-title">
                    <Text type={TextTypes.H3}>Frequently Asked Questions</Text>
                </Col>
            </Row>
            {data.map((block, i) => (
                <Row className="faq-group" key={i}>
                    <Col>
                        <Text type={TextTypes.H3} className="d-none d-md-block">
                            {block.title}
                        </Text>
                        <Text
                            type={TextTypes.SUB1}
                            className="d-md-none d-sm-block"
                        >
                            {block.title}
                        </Text>
                        {block.questions.map((faq, j) => {
                            return <FaqBlock faq={faq} key={j} />
                        })}
                        <br />
                    </Col>
                </Row>
            ))}
            <Row>
                <Col style={{ textAlign: 'center' }}>
                    <div style={{ height: 40 }} />
                    <Text type={TextTypes.SUB2} className="sub2 mb-16">
                        If there are any other concerns or issues not answered by this FAQ please
                        contact support for further assistance.
                    </Text>
                    <Text type={TextTypes.SUB2} className="sub2 mb-24">
                        You can email <a href="mailto:restaurantpos@spoton.com">restaurantpos@spoton.com</a>{' '}
                        support or call 877-814-4102 to speak to a support agent.
                    </Text>
                    <div style={{ height: 40 }} className="d-md-none d-sm-block" />
                </Col>
            </Row>
        </Container>
    );
}

const query = () => {
    return Promise.resolve({
        status: 0,
        customstyle: storage.getCustomStyle(),
    });
};

export default styleLoader(Faq, query);
